<template>

  <div class="page">
    <div class="nav1">
      员工管理
      <div @click="showAction = true" class="link">
        <van-icon name="setting-o" />
      </div>
    </div>

    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height:calc(100vh - 80px);background: #fff;">

      <van-search v-model="kw" show-action label="" placeholder="请输入搜索关键词" @search="onSearch" @clear="onClear">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>

      <div class="list">
        <!-- <van-cell v-for="item in list" :key="item.applyId" :title="item.applyId" /> -->

        <van-cell v-for="item in list" :key="item.employeeId" is-link center :title="`${item.name}`"
          :label="`${item.mobile}`">
          <template #right-icon>
            <van-icon name="delete-o" @click="del(item)" />
          </template>
        </van-cell>


      </div>
      <div class="nodata" v-if="list && list.length === 0">
        <div class="iconfont icon-queshengye_zanwushuju" style="font-size:100px;color:#3a88f2"></div>
        暂无数据
      </div>
    </van-pull-refresh>

    <van-action-sheet v-model="showAction" :actions="actions" cancel-text="取消" close-on-click-action
      @cancel="showAction = false" @select="getLink" />

  </div>
</template>

<script>
import { NavBar, PullRefresh, Search, ActionSheet } from 'vant'

export default {
  data() {
    return {
      showAction: false,
      actions: [{ name: '普通员工', key: "10" }, { name: '行政管理', key: '20' }],
      kw: '',
      isLoading: false,
      loading: false,
      finished: false,
      error: null,
      empty: true,
      list: null
    }
  },
  mounted() {
    this.onLoad();
  },
  components: {
    'van-nav-bar': NavBar,
    'van-pull-refresh': PullRefresh,
    'van-search': Search,
    'van-action-sheet': ActionSheet
  },
  methods: {
    copy(message) {
      var input = document.createElement("input");
      input.value = message;
      document.body.appendChild(input);
      input.setAttribute("readonly", "readonly");
      input.select();
      input.setSelectionRange(0, input.value.length), document.execCommand('Copy');
      this.$toast('链接已复制')
    },
    getLink(e) {
      this.axios
        .get('employee/getLink', { params: { roleCode: e.key } })
        .then(res => {
          let successUrl = `${window.location.origin}/employee/bind?t=${res.data}`
          console.log(successUrl)
          this.copy(successUrl)
        });

    },
    onSearch() {
      console.log(this.kw)
      this.list = [... this.list.filter(t => { return t.name.indexOf(this.kw) > -1 || t.mobile.indexOf(this.kw) > -1 })]
    },
    onClear() {
      this.kw = "";
      this.onLoad()
    },
    onClickLeft() { },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.empty = null;
      this.list = []
      this.onLoad()
    },
    goInfo(record) {
      this.$router.go({ path: '/appointment/info', query: { id: record.applyId } })
    },
    onLoad() {

      this.axios
        .get('employee/m_list', { params: { current: 1, pageSize: 200 } })
        .then(res => {
          if (res.errorCode == 0) {

            this.list = [...res.data];

            this.loading = false
            this.isLoading = false
            this.finished = true



          } else {
            this.loading = false
            this.isLoading = false
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })



    },
    del(item) {
      this.$dialog.alert({
        title: '系统提示',
        message: '确定要删除该员工?',
        showCancelButton: true,
      }).then(res => {
        this.delAction(item)
      })
    },
    delAction(item) {
      this.axios
        .post('employee/set', { keys: [item.employeeId], type: -10, })
        .then(res => {
          if (res.errorCode == 0) {
            this.isLoading = false
            console.log(res.data)
            this.onLoad()
            // 跳转到下一步
            this.$dialog.alert({
              title: '系统提示',
              message: '删除成功'
            }).then(res => {
            })
          } else {
            this.isLoading = false
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })
    }
  }
}
</script>

<style scoped lang="less">
.page {
  min-height: 100vh;
  background: #3a88f2;
}

.link {
  height: 20px;
  position: absolute;
  right: 15px;
  top: 30px;
  font-size: 16px;
  line-height: 30px;
  color: #FFF;
}

.list {
  .item {
    .header {
      line-height: 30px;

      span {
        float: right;
        padding: 0 10px;
      }
    }

    ::after {
      display: block;
      content: '';
      border-top: solid 1px #FFF;
      width: 100%;
    }
  }

}
</style>
